<script setup>
import { toRef } from 'vue';
import { useChannelIcon } from './provider';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
  conversationType: {
    type: String,
    default: '',
  },
});

const channelIcon = useChannelIcon(
  toRef(props, 'inbox'),
  toRef(props, 'conversationType')
);
</script>

<template>
  <Icon :icon="channelIcon" />
</template>
